import { action, observable } from "mobx";

import { CREATE_HOME_CLAIM } from "../../graphql-documents/createHomeClaim.mutation";
import extractHomeClaimPayload from "../../utilities/extractHomeClaimPayload";
import { personalInfoToGraphQL } from "../../utilities/mapFormValuesToGraphQL";

class PersonalInfoStore {
  @observable propertyId;
  @observable userId;

  @observable loading = false;
  @observable data = null;
  @observable error = null;

  constructor({ analyticsService, graphqlMutationService }) {
    this.graphqlMutationService = graphqlMutationService;
    this.analyticsService = analyticsService;
  }

  @action.bound
  initialize({ propertyId, userId }) {
    this.propertyId = propertyId;
    this.userId = userId;
  }

  @action.bound
  setPropertyId(value) {
    this.propertyId = value;
  }

  @action.bound
  handlePersonalInfoFormSubmit(
    formValues,
    { onComplete, onFieldValidationError }
  ) {
    this.loading = true;

    return this.graphqlMutationService
      .mutate({
        mutation: CREATE_HOME_CLAIM,
        variables: {
          property_id: this.propertyId,
          user_id: this.userId,
          ...personalInfoToGraphQL(formValues)
        }
      })
      .then(payload => {
        const { data, errors: fieldValidationErrors } = extractHomeClaimPayload(
          payload
        );

        if (fieldValidationErrors) {
          onFieldValidationError(fieldValidationErrors);
          return null;
        }

        this.analyticsService.sendHomeownerInfoSubmit();

        return data;
      })
      .then(
        action(data => {
          this.data = data;
          this.error = null;
        })
      )
      .catch(
        action(error => {
          this.data = null;
          this.error = error;
        })
      )
      .finally(
        action(() => {
          this.loading = false;
          onComplete();
        })
      );
  }
}

export default PersonalInfoStore;
